import { CircleCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
const trustItems = [{
  id: 1,
  label: "Infrastructure",
  title: "AWS Advanced Tier Partner"
}, {
  id: 2,
  label: "Development",
  title: "React Core Expert Network"
}, {
  id: 3,
  label: "Compliance",
  title: "GDPR & SOC2 Type II Certified"
}, {
  id: 4,
  label: "Performance",
  title: "Cloudflare Global Edge Network"
}];
export default function Trustbar() {
  return <section data-section-id="103795" id="our-network" className="w-full bg-background py-12 border-y border-border">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-border/20 border border-border/20">
          {trustItems.map((item, i) => <div key={item.id} data-index={i} className="bg-background p-6 flex flex-col justify-between min-h-[140px] group opacity-60 hover:opacity-100 transition-opacity duration-300">
              <div className="flex items-start justify-between w-full mb-6">
                <CircleCheck className="w-5 h-5 text-primary" strokeWidth={1.5} aria-hidden="true" />
                <Badge variant="outline" className="font-mono text-[9px] uppercase tracking-widest text-primary border-primary/40 rounded-none bg-transparent px-2 py-0.5">
                  Verified
                </Badge>
              </div>
              
              <div>
                <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mb-1.5">
                  {item.label}
                </div>
                <div className="font-sans text-sm font-bold text-foreground leading-tight">
                  {item.title}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}